import { type FunctionComponent } from 'react'

import useConsumptionTotal from 'src/hooks/composite/costs/useConsumptionTotal'

import { formatCurrency } from 'src/utils/format'

import moment from 'moment'
import { PiTrendDownBold, PiTrendUpBold } from 'react-icons/pi'
import { useNavigate } from 'react-router'

import { Tile, TileHeader } from '../Tile'

// Define date ranges
const startOfThisYear = moment().startOf('year')
const today = moment().startOf('day').subtract(1, 'day')

const startOfLastYear = moment(startOfThisYear).subtract(1, 'year')
const todayLastYear = moment(today).subtract(1, 'year')

const ytdDateRange = [startOfThisYear, today] as [moment.Moment, moment.Moment]
const lastYearDateRange = [startOfLastYear, todayLastYear] as [moment.Moment, moment.Moment]

const AzureYearToDateTile: FunctionComponent = () => {
  const navigate = useNavigate()

  // Get consumption data
  const ytdConsumptionTotal = useConsumptionTotal({ dateRange: ytdDateRange })
  const lastYearConsumptionTotal = useConsumptionTotal({ dateRange: lastYearDateRange })

  // Calculate change
  const percentChange =
    lastYearConsumptionTotal && ytdConsumptionTotal && lastYearConsumptionTotal !== 0
      ? Math.round(((ytdConsumptionTotal - lastYearConsumptionTotal) / lastYearConsumptionTotal) * 100)
      : 0

  const isIncrease = percentChange > 0
  const TrendIcon = isIncrease ? PiTrendUpBold : PiTrendDownBold
  const changeText = `(${isIncrease ? '+' : ''}${percentChange}%)`

  return (
    <Tile onMouseDown={() => navigate('/azure_overview')}>
      <TileHeader>
        <TileHeader.Title className="flex items-center gap-2">
          {ytdConsumptionTotal ? formatCurrency(Math.round(ytdConsumptionTotal)) : 'Loading...'}
          {percentChange !== 0 && <div className="mt-1 text-xs font-medium text-th-text-secondary">{changeText}</div>}
        </TileHeader.Title>
        <TileHeader.Subtitle>Azure Cost Year To Date</TileHeader.Subtitle>
        <TileHeader.Item>
          <TrendIcon className="h-10 w-10 text-th-primary" />
        </TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default AzureYearToDateTile
